import React, { useContext } from "react";
import { Link, NavLink } from "react-router-dom";

import KeycloakContext from "../../../context/keycloakContext";

import withActivityTracer from "../../../hoc/withActivityTracer";

const SideBar = ({ setting }) => {
  const { logout } = useContext(KeycloakContext);

  return (
    <div className="l-navbar" id="nav-bar">
      <nav className="nav">
        <div>
          {" "}
          <Link to="#" className="nav_logo text-decoration-none">
            {" "}
            <img
              src={`${process.env.PUBLIC_URL}/logo192.png`}
              width="35"
              height="35"
              className="d-inline-block nav_logo_icon"
              alt="Histocaching"
            />{" "}
            <span className="nav_logo_name">{setting.name}</span>
          </Link>
          <div className="nav_list">
            {" "}
            <NavLink
              title="Overview"
              className="nav_link text-decoration-none"
              to="/dashboard/overview"
            >
              {" "}
              <i className="bx bx-globe nav_icon"></i>{" "}
              <span className="nav_name">Overview</span>{" "}
            </NavLink>{" "}
            <NavLink
              title="Categories"
              className="nav_link text-decoration-none"
              to="/dashboard/categories"
            >
              {" "}
              <i className="bx bx-category-alt nav_icon"></i>{" "}
              <span className="nav_name">Categories</span>{" "}
            </NavLink>{" "}
            <NavLink
              title="Tags"
              className="nav_link text-decoration-none"
              to="/dashboard/tags"
            >
              {" "}
              <i className="bx bx-purchase-tag-alt nav_icon"></i>{" "}
              <span className="nav_name">Tags</span>{" "}
            </NavLink>{" "}
            <NavLink
              title="Histocaches"
              className="nav_link text-decoration-none"
              to="/dashboard/pois"
            >
              {" "}
              <i className="bx bx-map nav_icon"></i>{" "}
              <span className="nav_name">Histocaches</span>{" "}
            </NavLink>{" "}
            <NavLink
              title="Viewpoints"
              className="nav_link text-decoration-none"
              to="/dashboard/viewpoints"
            >
              {" "}
              <i className="bx bx-location-plus nav_icon"></i>{" "}
              <span className="nav_name">Viewpoints</span>{" "}
            </NavLink>{" "}
            <NavLink
              title="Items"
              className="nav_link text-decoration-none"
              to="/dashboard/items"
            >
              {" "}
              <i className="bx bx-layer nav_icon"></i>{" "}
              <span className="nav_name">Items</span>{" "}
            </NavLink>{" "}
            <NavLink
              title="Tours"
              className="nav_link text-decoration-none"
              to="/dashboard/tours"
            >
              {" "}
              <i className="bx bx-been-here nav_icon"></i>{" "}
              <span className="nav_name">Tours</span>{" "}
            </NavLink>{" "}
            <NavLink
              title="Sections"
              className="nav_link"
              to="/dashboard/sections"
            >
              {" "}
              <i className="bx bx-volume-full nav_icon"></i>{" "}
              <span className="nav_name">Sections</span>{" "}
            </NavLink>{" "}
            {setting.has_folders_module && (
              <NavLink
                title="Folders"
                className="nav_link text-decoration-none"
                to="/dashboard/folders"
              >
                {" "}
                <i className="bx bx-folder nav_icon"></i>{" "}
                <span className="nav_name">Folders</span>{" "}
              </NavLink>
            )}{" "}
            {setting.has_files_module && (
              <NavLink
                title="Files"
                className="nav_link text-decoration-none"
                to="/dashboard/files"
              >
                {" "}
                <i className="bx bx-file-blank nav_icon"></i>{" "}
                <span className="nav_name">Files</span>{" "}
              </NavLink>
            )}{" "}
            <NavLink
              title="Overview"
              className="nav_link text-decoration-none"
              to="/dashboard/settings"
            >
              {" "}
              <i className="bx bx-cog nav_icon"></i>{" "}
              <span className="nav_name">Settings</span>{" "}
            </NavLink>{" "}
          </div>
        </div>{" "}
        <Link
          title="Logout"
          className="nav_link text-decoration-none"
          onClick={() => logout()}
          to="/logout"
        >
          {" "}
          <i className="bx bx-log-out nav_icon"></i>{" "}
          <span className="nav_name">Logout</span>{" "}
        </Link>
      </nav>
    </div>
  );
};

// export default SideBar;
export default withActivityTracer(SideBar);
